import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const DetailItem = ({ label, value }) => {
	return (
		<Box sx={{ display: 'flex' }}>
			<Typography mr={1} sx={{ fontWeight: 600 }}>
				{label}:
			</Typography>
			<Typography>{value}</Typography>
		</Box>
	);
};

export default DetailItem;
